const isMultiBranches = () => {
  return window.location.search.search('type=m') == -1 ? false : true;
};

export default isMultiBranches;
